import { getContext, setContext } from 'svelte'

export type BoardStyle = 'classic' | 'signs'
export const STYLE_KEY = 'ops:style:v1'
const CONTEXT = Symbol('ops appearance')
const validStyle = (value: unknown): value is BoardStyle => value === 'classic' || value === 'signs'

/** Presentation is independent of the report, filters and saved favourites. */
export class Appearance {
  value = $state<BoardStyle>('classic')

  constructor(search = typeof location === 'undefined' ? '' : location.search) {
    let saved: string | null = null
    try {
      saved = localStorage.getItem(STYLE_KEY)
    } catch {
      /* Use Classic when storage is blocked. */
    }
    const linked = new URLSearchParams(search).get('style')
    this.value = validStyle(linked) ? linked : validStyle(saved) ? saved : 'classic'
  }

  apply() {
    document.documentElement.dataset.opsStyle = this.value
    try {
      localStorage.setItem(STYLE_KEY, this.value)
    } catch {
      /* Keep the choice for this visit. */
    }
  }

  choose(value: BoardStyle) {
    this.value = value
    // A choice must override an explicit link while retaining its area and filters.
    const url = new URL(location.href)
    url.searchParams.set('style', value)
    if (url.href !== location.href) history.replaceState(history.state, '', url)
  }
}

export function provideAppearance(appearance: Appearance) {
  setContext(CONTEXT, appearance)
}
export function useAppearance(): Appearance {
  return getContext<Appearance | undefined>(CONTEXT) ?? new Appearance()
}
